namespace Recommendations {
    function HomeRecommender(
        $location: ng.ILocationService,
        $q: ng.IQService,
        houseRecommender: any,
        recommender: any,
        recommenderUiHelper: RecommenderUiHelper
    )
    {
        return {
            scope: {
                placementId: '@',
                hideDestinations: '=',
                imgWidth: '@'
            },
            replace: true,
            templateUrl: 'partials/recommendations/homerecommender',
            link($scope, $element) {

                $q.all([
                        recommender.getHotelsForLanding($scope.placementId, { imgWidth: $scope.imgWidth }),
                        houseRecommender.getHouseRecs()
                    ])
                    .then(([{ hotels, trackView, trackClick }, destinations]) => {
                        if (!hotels || !hotels.length) {
                            trackView(0, 0, 0, []);
                            return $scope.hotels = [];
                        }
                        _.assign(
                            $scope,
                            {
                                track: houseRecommender.trackHouseClick,
                                hotels,
                                destinations,
                                selectHotel: hotel => {
                                    trackClick(hotel, recommenderUiHelper.getPageSize());
                                    $location.path(hotel.Url);
                                }
                            }
                        );

                        recommenderUiHelper.bindCarouselEvents($element, hotels, trackView);
                });
            }
        };
    }

    angular
        .module('recommendations')
        .directive('homeRecommender', HomeRecommender);
}
